import styled from "styled-components";
import { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { CreateSpace } from "./CreateSpace";
import { QandA } from "./QandA";
import { CommunitiesSidebar } from "../CommunitiesSidebar";
import { CreateCommunityModal } from "../Communities/CreateCommunityModal";

export const HomeMain = () => {
    const location = useLocation();
    const history = useHistory();
    const [openCreate, setOpenCreate] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("createcommunity") === "1") {
            setOpenCreate(true);
            history.replace("/home");
        }
    }, [location, history]);

    return (
        <Home>
            <StyledHome>
                <CreateSpace className="space" />
                <div className="QandA">
                    <QandA />
                </div>
                <CommunitiesSidebar className="follow" />
            </StyledHome>
            <CreateCommunityModal open={openCreate} onClose={() => setOpenCreate(false)} />
        </Home>
    );
};

const StyledHome = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 1.5rem;
    max-width: 1420px;
    width: 95%;
    margin: 0 auto;
    padding-top: 1rem;
    background-color: transparent;

    .space {
        flex-shrink: 0;
    }

    .QandA {
        flex: 1;
        max-width: 840px;
        min-width: 0;
    }

    .follow {
        flex-shrink: 0;
    }

    /* Small laptops & below: drop the right sidebar */
    @media (max-width: 1280px) {
        .follow {
            display: none;
        }
    }

    /* Tablet-ish: drop left sidebar too so the feed gets full width */
    @media (max-width: 980px) {
        gap: 0.75rem;
        .space {
            display: none;
        }
    }

    /* Mobile breakpoint (< 768px) */
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding-top: 0.5rem;

        .QandA {
            width: 100%;
            max-width: 100%;
            padding: 0 0.5rem;
        }
    }
`;

const Home = styled.div`
    background-color: transparent;
`;
